export default [
    {
        date: 1584567654352,
        row: 27,
        col: 20,
        segments: [
            [9, 5, 11, 5],
            [11, 5, 13, 6],
            [13, 6, 14, 8],
            [14, 8, 14, 10],
            [14, 10, 13, 12],
            [13, 12, 11, 13],
            [11, 13, 9, 13],
            [9, 13, 7, 12],
            [7, 12, 6, 10],
            [6, 10, 6, 8],
            [6, 8, 7, 6],
            [7, 6, 9, 5],
            [9, 5, 6, 3],
            [6, 3, 6, 8],
            [11, 5, 14, 3],
            [14, 3, 14, 8],
            [9, 9, 10, 10],
            [10, 10, 11, 9],
            [11, 9, 9, 9],
            [10, 10, 10, 11],
            [10, 11, 9, 11],
            [9, 11, 8, 10],
            [10, 11, 11, 11],
            [11, 11, 12, 10],
            [11, 7, 11, 8],
            [11, 8, 12, 8],
            [12, 8, 12, 7],
            [12, 7, 11, 7],
            [9, 7, 9, 8],
            [9, 8, 8, 8],
            [8, 8, 8, 7],
            [8, 7, 9, 7],
            [9, 13, 9, 14],
            [11, 13, 11, 14],
            [9, 14, 7, 14],
            [11, 14, 13, 14],
            [7, 14, 6, 15],
            [13, 14, 14, 15],
            [14, 15, 14, 25],
            [8, 25, 8, 26],
            [8, 26, 10, 26],
            [10, 26, 12, 26],
            [12, 26, 12, 25],
            [7, 16, 7, 21],
            [7, 21, 8, 25],
            [12, 25, 13, 21],
            [13, 21, 13, 16],
            [6, 25, 8, 25],
            [12, 25, 14, 25],
            [6, 18, 5, 18],
            [14, 18, 15, 18],
            [15, 18, 16, 21],
            [15, 25, 14, 25],
            [5, 18, 4, 21],
            [5, 25, 6, 25],
            [16, 24, 15, 25],
            [16, 24, 16, 21],
            [4, 24, 4, 21],
            [4, 24, 5, 25],
            [18, 27, 14, 27],
            [17, 25, 17, 26],
            [17, 25, 15, 25],
            [14, 26, 14, 27],
            [14, 26, 17, 26],
            [16, 24, 18, 24],
            [18, 24, 18, 27],
            [6, 18, 6, 25],
            [6, 15, 6, 18],
            [9, 16, 10, 21],
            [10, 21, 11, 16],
            [10, 21, 10, 26],
        ],
    },
];
